import { api } from "roboflex-thalamus-request-handler";

export default {
    async listarTodosProtocolos() {
        try {
            const response = await api.get("protocolo/listar");
            return response.data;
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error;
        }
    },

    async listarPorTipo(tipoId) {
        const response = await api.get(`protocolo/listar?tipo_id=${tipoId}`);
        return response.data;
    },

    /**
     * XLSX com o mesmo critério de listagem por tipo (GET protocolo/listar?tipo_id=&format=xlsx).
     * @param {string|number} tipoId
     */
    async downloadListaExcelPorTipo(tipoId) {
        const response = await api.get("protocolo/listar", {
            params: { tipo_id: tipoId, format: "xlsx" },
            responseType: "blob",
            validateStatus: () => true,
        });

        const ct = response.headers["content-type"] || "";
        if (ct.includes("application/json")) {
            const text = await response.data.text();
            let msg = "Erro ao gerar relatório";
            try {
                const j = JSON.parse(text);
                msg = j.message || j.error || msg;
            } catch (_) {
                /* ignore */
            }
            throw new Error(msg);
        }

        if (response.status !== 200) {
            throw new Error("Erro ao gerar relatório");
        }

        const blob = response.data;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        let filename = `protocolos_tipo_${tipoId}.xlsx`;
        const cd = response.headers["content-disposition"];
        if (cd) {
            const m = /filename\*?=(?:UTF-8''|")?([^";\n]+)/i.exec(cd);
            if (m) {
                filename = decodeURIComponent(m[1].replace(/"/g, "").trim());
            }
        }
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    },

    async listarTipos() {
        const response = await api.get("protocolo/tipo/listar");
        return response.data;
    },

    async listarEntidades() {
        const response = await api.get("protocolo/entidades/listar");
        return response.data;
    },

    async gravarProtocolo(payload) {
        const response = await api.post("protocolo/gravar", payload);
        return response.data;
    },

    async getProtocoloById(id) {
        try {
            const response = await api.get(`protocolo/buscar/${id}`);
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error;
        }
    },

    async editarProtocolo(id, itemAlterado, novoValor, usuarioId) {
        try {
            const response = await api.post(`protocolo/atualizar/${id}`, {
                usuario_id: usuarioId,
                [itemAlterado]: novoValor,
            });
            return response.data;
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error;
        }
    },

    async editarTarefa(idTarefa, payload) {
        try {
            const response = await api.put(`protocolo/tarefa/atualizar/${idTarefa}`, payload);
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error;
        }
    },

    async adicionarTarefa(payload) {
        try {
            const response = await api.post(`protocolo/tarefa/gravar`, payload);
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error;
        }
    },

    async excluirTarefa(idTarefa, idUsuario) {
        try {
            const response = await api.post(`/protocolo/tarefa/excluir/${idTarefa}`, {
                usuario_id: idUsuario
            });
            return response.data;
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error;
        }
    },

    async atualizarProtocoloComFormData(id, formData) {
        const response = await api.post(`protocolo/atualizar/${id}`, formData);
        return response.data;
    },

    async excluirAnexoProtocolo(idAnexo) {
        await api.delete(`protocolo/anexo/remover/${idAnexo}`);
    },

    async adicionarAnexoTarefa(formData) {
        const response = await api.post(`protocolo/tarefa/anexo/adicionar`, formData);
        return response.data;
    },

    async listarAlteracoes(protocoloId, tarefaId = null) {
        const params = new URLSearchParams({ protocolo_id: protocoloId });
        if (tarefaId != null) params.set('tarefa_id', tarefaId);
        const response = await api.get(`protocolo/alteracoes/listar?${params.toString()}`);
        return response.data;
    }
};